import { render, staticRenderFns } from "./VideoManagementNew.vue?vue&type=template&id=1ebc8cda&scoped=true"
import script from "./VideoManagementNew.vue?vue&type=script&lang=js"
export * from "./VideoManagementNew.vue?vue&type=script&lang=js"
import style0 from "./VideoManagementNew.vue?vue&type=style&index=0&id=1ebc8cda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebc8cda",
  null
  
)

export default component.exports